import { VStack, colors, Spacing } from "goi_common";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";
import HomeV4PrimaryButton from "./HomeV4PrimaryButton";

interface HomeV4BenefitCardProps {
  top?: ReactNode;
  middle?: ReactNode;
  buttonText?: string;
  background?: string;
  onClick?: () => void;
}

export default function HomeV4BenefitCard({
  top,
  middle,
  buttonText = "고이 상조 자세히 보기",
  background = colors.gray50,
  onClick,
}: HomeV4BenefitCardProps) {
  return (
    <VStack
      background={background}
      width="100%"
      overflow="hidden"
      alignItems="center"
      position="relative"
      padding="40px 20px"
      borderRadius="12px"
    >
      <Box textAlign="center" whiteSpace="pre-line">
        <Box className="body_16_r" color={colors.gray700}>
          {top}
        </Box>
      </Box>

      <Spacing gap={34} />

      {middle && (
        <>
          {middle}
          <Spacing gap={32} />
        </>
      )}

      <HomeV4PrimaryButton onClick={onClick}>{buttonText}</HomeV4PrimaryButton>
    </VStack>
  );
}
